import { Note } from "ng/src/app/notes/shared/note.model";
import { AppStateService } from "../../core/services/app-state.service";
import { NotesTableService } from "../notes-table/notes-table.service";
import { HasId } from "app/shared/model/properties.model";
import { Utils } from "ng/src/app/core/utils";

type DisplayNoteBase = Pick<Note, 'newMillis' | 'tagValues' | 'richText' | 'safeHtmlNote' | 'maxHeight'>;

export type DisplayNote<T extends DisplayNoteBase = DisplayNoteBase> = T & HasId & {
	safeHtmlNoteAbridged?: string;
	showAbridgedNote?: boolean;
}

export module DisplayNote {
	export function setAbridgedNote<T extends DisplayNoteBase>(note: T): DisplayNote<T> {
		const displayNote = note as DisplayNote<T>;

		if (!note.maxHeight || isDisplayNote(note))
			return displayNote;
		
		let match: RegExpExecArray | null = null;
		const tagsToMatch = /<\/tr>|<\/span>|<\/p>|<\/h1>|<\/h2>|<\/h3>|<\/h4>|<\/h5>/g;
		
		for (let i = 0; i < note.maxHeight; i++) {
			const maxHeightEqualsTagCount = () => {
				return i == note.maxHeight - 1 &&
					note.safeHtmlNote.substring(tagsToMatch.lastIndex).search(tagsToMatch) == -1;
			}
			
			match = tagsToMatch.exec(note.safeHtmlNote);
			
			if (!match || maxHeightEqualsTagCount()) {
				match = null;
				break;
			}
		}
		
		if (match) {
			const showAbridgedNote = AppStateService.preferences.getValue(NotesTableService.defaultToAbridgedKey, true);

			displayNote.safeHtmlNoteAbridged = note.safeHtmlNote.substring(0, tagsToMatch.lastIndex);
			displayNote.showAbridgedNote = showAbridgedNote;
		}

		return displayNote;
	}
	
	export function updateShowing<T extends DisplayNoteBase>(target: DisplayNote<T>, source: DisplayNote | boolean): DisplayNote<T> {
		if (target.safeHtmlNoteAbridged == null) {
			target.showAbridgedNote = false;
			return target;
		}
		target.showAbridgedNote = (typeof source === 'boolean') ? source : !!source.showAbridgedNote;
		return target;
	}
	
	export function toggleShowing<E extends DisplayNote>(note: E, showing?: boolean): E {
		return updateShowing(note, typeof showing === 'boolean' ? showing : !note.showAbridgedNote);
	}
	
	function isDisplayNote(val: any) {
		const isDisplayNote = !!val.__isDisplayNote;
		val.__isDisplayNote = true;

		return isDisplayNote;
	}
}